import { useGetMemberTraitsQuery } from "@apis/traits/useTraits"
import { Tooltip, TooltipContent, TooltipTrigger } from "@components/ui/tooltip"
import { traitsIconParser, iconColorClass } from "./traitsIconParser"
import { cn } from "@components/ui/lib/utils"
import { Loader2 } from "lucide-react"

type TTraitsProps = {
  prospect_guid: string
}

const Traits = ({ prospect_guid }: TTraitsProps) => {
  const {
    data: memberTraits,
    isError,
    error,
    isPending,
  } = useGetMemberTraitsQuery(prospect_guid)

  if (isPending) {
    return (
      <Loader2 className="tw:h-6 tw:w-6 tw:animate-spin tw:text-gray-500" />
    )
  }

  if (isError) {
    return (
      <div className="tw:text-red-500">
        There was an error loading member traits. Error: {error.message}
      </div>
    )
  }

  return (
    <div className="tw:flex tw:flex-wrap tw:gap-2 tw:py-2">
      {memberTraits?.map((trait) => {
        const Icon = traitsIconParser(trait.trait_icon)
        if (!Icon) return null

        return (
          <Tooltip key={`${trait.trait_description}`}>
            <TooltipTrigger>
              <Icon
                className={cn(
                  "tw:h-8 tw:w-8",
                  iconColorClass(trait.trait_icon),
                )}
              />
            </TooltipTrigger>
            <TooltipContent side="bottom">
              <span>{trait.trait_description}</span>
            </TooltipContent>
          </Tooltip>
        )
      })}
    </div>
  )
}

export default Traits
